import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { ContentObjectTypes } from 'content-management-data-lib';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
const fetchPersonalizedPages = async ({
  strategyId,
  contentObjectType
}) => {
  const data = await http.post(`content-management/search/v1/${contentObjectType !== null && contentObjectType !== void 0 ? contentObjectType : ContentObjectTypes.LANDING_PAGE}`, {
    data: {
      filterGroups: [{
        filters: [strategyId ? {
          property: PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID,
          operator: 'EQ',
          value: strategyId
        } : {
          property: PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID,
          operator: 'HAS_PROPERTY'
        }]
      }],
      sorts: [{
        property: PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID,
        order: 'DESC'
      }]
    }
  });
  return data;
};
const PERSONALIZED_LANDING_PAGES_QUERY_FIELD_NAME = 'personalizedPages';
export const PersonalizedPagesQuery = registerQuery({
  fieldName: PERSONALIZED_LANDING_PAGES_QUERY_FIELD_NAME,
  fetcher: fetchPersonalizedPages,
  args: ['strategyId', 'contentObjectType']
});